import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, transitions } from '@twisto/styles'

export const root = (theme: Theme) => css`
  width: 100%;
  color: ${theme.palette.neutral[700]};
  display: block;
  position: relative;

  height: 16px;

  ${breakpoint.up('md')} {
    height: 18px;
  }
`

export const wrapper = css`
  top: 0;
  width: 100%;
  position: absolute;
  transition: top ${transitions.default};
`

export const flexibleWrapper = css`
  top: 16px;
  pointer-events: none;

  ${breakpoint.up('md')} {
    top: 22px;
  }
`

export const textTransition = css`
  overflow: hidden;
  white-space: nowrap;
  transition:
    color,
    font-size ${transitions.default};
`

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.neutral[600]};
`

export const placeholder = (theme: Theme) => css`
  /* 16px to prevent ios zooming */
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${theme.palette.neutral[700]};

  text-overflow: ellipsis;
`
